import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { FavouriteGamesError } from "./favourite-games.model";

export const ACTION_PREFIX = "[Favourite Games]";
export const FAVOURITE_GAMES_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,

	toggle: `${ACTION_PREFIX} Toggle ${SYNC_SUFFIX}`,

	add: `${ACTION_PREFIX} Add`,
	addSuccess: `${ACTION_PREFIX} Add Success`,
	addFail: `${ACTION_PREFIX} Add Fail`,

	remove: `${ACTION_PREFIX} Remove`,
	removeSuccess: `${ACTION_PREFIX} Remove Success`,
	removeFail: `${ACTION_PREFIX} Remove Fail`,

	reset: `${ACTION_PREFIX} Reset ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class FavouriteGamesAction {
	getAll(): Action {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.getAll,
		};
	}

	getAllSuccess(favouriteGames: string[]): ActionWithPayload {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.getAllSuccess,
			payload: favouriteGames,
		};
	}

	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}

	toggle(gameId: string): ActionWithPayload {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.toggle,
			payload: gameId,
		};
	}

	add(gameId: string): ActionWithPayload {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.add,
			payload: gameId,
		};
	}

	addSuccess(): Action {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.addSuccess,
		};
	}

	addFail(error: AppError, gameId: string): ActionWithPayload {
		const payload: FavouriteGamesError = Object.assign(error, {
			gameId,
		});

		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.addFail,
			payload,
		};
	}

	remove(gameId: string): ActionWithPayload {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.remove,
			payload: gameId,
		};
	}

	removeSuccess(): Action {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.removeSuccess,
		};
	}

	removeFail(error: AppError, gameId: string): ActionWithPayload {
		const payload: FavouriteGamesError = Object.assign(error, {
			gameId,
		});

		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.removeFail,
			payload,
		};
	}

	reset(): Action {
		return {
			type: FAVOURITE_GAMES_ACTION_TYPE.reset,
		};
	}
}
